__webpack_require__.p = "/memory-card-game-TOP/";